import ChairIcon from "@mui/icons-material/Chair";
import StorefrontIcon from "@mui/icons-material/Storefront";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { ViewMode } from "../../constante/viewMode";
import { setButtonsState } from "../../redux/features/appStateSlice";
import { useAppDispatch, useAppSelector } from "../../redux/store";

export const ViewToggleButton = () => {
  const dispatch = useAppDispatch();
  const buttonsState = useAppSelector((state) => state.appState.buttonsState);

  const handleClick = (value: ViewMode) => {
    switch (value) {
      case ViewMode.product:
        dispatch(setButtonsState({ productView: true, storeView: false }));
        break;
      case ViewMode.store:
        dispatch(setButtonsState({ productView: false, storeView: true }));
        break;
      default:
        break;
    }
  };

  return (
    <ToggleButtonGroup id="view-toggle-button" exclusive>
      <ToggleButton
        value={ViewMode.product}
        selected={buttonsState.productView}
        onClick={(_event, value: ViewMode) => handleClick(value)}
      >
        <ChairIcon /><span>Produit</span>
      </ToggleButton>
      <ToggleButton
        value={ViewMode.store}
        selected={buttonsState.storeView}
        onClick={(_event, value: ViewMode) => handleClick(value)}
      >
        <StorefrontIcon /><span>Magasin</span>
      </ToggleButton>
    </ToggleButtonGroup>
  );
}